import { render } from "./Sunyuan.vue?vue&type=template&id=1ec28cec&scoped=true"
import script from "./Sunyuan.vue?vue&type=script&lang=js"
export * from "./Sunyuan.vue?vue&type=script&lang=js"

import "./Sunyuan.vue?vue&type=style&index=0&id=1ec28cec&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec28cec"]])

export default __exports__